// extracted by mini-css-extract-plugin
module.exports = {"root":"aspect-ratio-box-module--root--3g2RM","inner":"aspect-ratio-box-module--inner--2QvFh"};